
  import { Vue, Component, Prop } from "vue-property-decorator";

  @Component
  export default class CustomScroll extends Vue {
    @Prop({ type: Boolean, default: false }) readonly primary!: boolean;

    get scrollClasses() {
      return {
        "primary": this.primary,
        "common": !this.primary,
      };
    }
  }
